<template>

  <v-hover v-slot:default="{ hover }">
    <v-card :class="{'ma-3': true, 'hover': hover}" outlined @click="selectHotel">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card-title v-text="hotel.name"/>
        </v-col>
      </v-row>
    </v-card>
  </v-hover>

</template>


<script>

  export default {
    props: {
      hotel: null
    },

    data: () => ({
      hover: false
    }),

    methods: {
      selectHotel() {
        this.$root.$emit('selectHotel', {
          id: this.hotel.id,
          name: this.hotel.name,
          city: this.hotel.static.location.address.city,
          country: this.hotel.static.location.address.country,
        });
        this.$router.push(`/hotels/${this.hotel.id}/sheet`);
      }
    }
  }

</script>


<style scoped>

  .hover {
    cursor: pointer;
    background-color: rgba(0,0,0,.05);
  }

</style>